// RemixCreator.js
// @author: anghello

import TextPhotoDefaults from "../enums/TextPhotoDefaults";
import FileHelper from "../helpers/FileHelper";
import { generateVideoThumb } from "../helpers/GenerateVideoThumb";
import ProcessImageForUpload from "../helpers/ProcessImageForUpload";
import RemixHelper from "../helpers/RemixHelper";
import PSO from "../services/PSO";
import Strings from "../translations/Translations";

const generateVideoThumbs = true;

export const RemixCreator = async ({ al, un, rstyle_sid, rsong_sid, rti, rstag, rde, remixMedia, songType, appleMusicParams, song }) => {
  let returnV = true, resultArray = {};
  let temporaryEids = [];

  if (!remixMedia || remixMedia.length === 0) {
    returnV = false;
  }
  
  if (returnV) {
    // Validating first/last elements
    if (generateVideoThumbs) {
      if (remixMedia[0].type === 'video' || remixMedia[remixMedia.length - 1].type === 'video') {
        let successOnGenerateVideoThumb = true;
        let firstThumbToAdd, lastThumbToAdd;

        if (remixMedia[0].type === 'video') {
          try {
            const videoThumb = await generateVideoThumb(remixMedia[0].file);
            if (videoThumb) {
              firstThumbToAdd = {
                file: videoThumb,
                src: videoThumb,
                type: 'blobfile',
                temporary: true
              };
            } else {
              successOnGenerateVideoThumb = false;
            }
          } catch (err) {
            console.error(err);
            successOnGenerateVideoThumb = false;
          }
        }
        if (remixMedia[remixMedia.length - 1].type === 'video') {
          try {
            const videoThumb = await generateVideoThumb(remixMedia[remixMedia.length - 1].file);
            if (videoThumb) {
              lastThumbToAdd = {
                file: videoThumb,
                src: videoThumb,
                type: 'blobfile',
                temporary: true
              };
            } else {
              successOnGenerateVideoThumb = false;
            }
          } catch (err) {
            console.error(err);
            successOnGenerateVideoThumb = false;
          }
        }

        if (successOnGenerateVideoThumb) {
          if (firstThumbToAdd) { remixMedia = [firstThumbToAdd, ...remixMedia]; }
          if (lastThumbToAdd) { remixMedia.push(lastThumbToAdd); }
        } else {
          returnV = false;
          resultArray.message = Strings('error_while_processing_video_s_try_again_later');
        }
      }
      
    } else {
      if (remixMedia[0].type === 'video' || remixMedia[remixMedia.length - 1].type === 'video') {
        returnV = false;
        resultArray.message = Strings('the_first_media_should_be_a_Photo');
      }
    }

    if (returnV) {
      const remixArguments = RemixHelper.getDefaultRemixArguments();
      remixArguments.al = al;
      remixArguments.un = un;
      remixArguments.rstyle_sid = rstyle_sid;
      remixArguments.rsong_sid = rsong_sid;
      remixArguments.rti = encodeURIComponent(rti);
      remixArguments.rstag = rstag;
      remixArguments.rde = encodeURIComponent(rde);

      // Inverting MEDIA array
      const localRemixMedia = (remixMedia) ? [...remixMedia].reverse() : [];

      let startagExists = false, errorOnStartag = false;
      try {
        const response = await PSO.checkStarTagExists({
          un: un,
          al: al,
          rstag: remixArguments.rstag
        });
        if (response && response.result) {
          if (response.result === 'success') {
            if (response.systemstartagexists && (response.systemstartagexists === 1 || response.systemstartagexists === '1')) {startagExists = true; }
            if (response.userstartagexists && (response.userstartagexists === 1 || response.userstartagexists === '1')) { startagExists = true; }
          } else {
            errorOnStartag = true;
          }
        }
      } catch (err) {
        errorOnStartag = true;
        returnV = false;
        console.error(err);
      }

      if (!startagExists && !errorOnStartag) {
        // Remix media
        let etxtjsonCreate;
        let renderedFileBLOBCreate;
        let originalFileBLOBCreate;

        if (localRemixMedia[0].type === 'mediapack') {
          const images = localRemixMedia;
          remixArguments.eti = 'remixPhoto.jpg';
          remixArguments.uptype = 1;
          remixArguments.upfn = images[0].eid;
        } else if (localRemixMedia[0].type === 'file') {
          const targetFile = localRemixMedia[0].file;
          const fileDataURI = await FileHelper.readFile(targetFile);
          const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
          remixArguments['Filedata'] = fileBLOB;
          remixArguments['Filename'] = targetFile.name;
        } else if (localRemixMedia[0].type === 'blobfile') {
          const fileBLOB = localRemixMedia[0].file;
          remixArguments['Filedata'] = fileBLOB;
          remixArguments['Filename'] = 'remixPhoto.jpg';
        } else if (localRemixMedia[0].type === 'textphoto') {
          if (localRemixMedia[0].layers && localRemixMedia[0].layers.length > 0 && localRemixMedia[0].layers[0] !== null) {
            const originalFileBLOB = await RemixHelper.generateBasePhotoWithLayer(localRemixMedia[0].layers);
            originalFileBLOBCreate = FileHelper.dataURItoBlob(originalFileBLOB);
            renderedFileBLOBCreate = FileHelper.dataURItoBlob(localRemixMedia[0].src);
            const txts = [];
            if (localRemixMedia[0].layers && localRemixMedia[0].layers.length > 0) {
              localRemixMedia[0].layers.forEach((item) => {
                if (item.type === 'text') {
                  let x = item.x;
                  let y = item.y;
                  const h = item.h;
                  const w = item.w;

                  if (item.textAlign === 'center') {
                    if (item.renderedW) {
                      x = x - (item.renderedW / 2);
                    }
                    if (item.renderedH) {
                      y = y - (item.renderedH / 2);
                    }
                  }

                  x = x - TextPhotoDefaults.COMPATIBILITY_X_FACTOR;
                  y = y - TextPhotoDefaults.COMPATIBILITY_Y_FACTOR;

                  txts.push({
                    t: RemixHelper.generateTextLayerBreakLine(item),
                    c: encodeURIComponent(item.color),
                    y: y,
                    x: x,
                    h: h,
                    w: w,
                    a: 0,
                    s: item.fontSize / TextPhotoDefaults.SCALE_FACTOR,
                    f: encodeURIComponent(item.font),
                    app: 'web'
                  });
                }
              });
            }

            etxtjsonCreate = { isTxtPhoto: true, txts: txts };
            remixArguments['etxtjson'] = JSON.stringify(etxtjsonCreate);
            remixArguments['Filedata'] = originalFileBLOBCreate;
            remixArguments['Filename'] = 'remixPhoto.jpg';
          }
        } else if (localRemixMedia[0].type === 'unsplash') {
          const targetFile = localRemixMedia[0];
          const fileDataURI = targetFile.src;
          const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
          remixArguments['Filedata'] = fileBLOB;
          remixArguments['Filename'] = targetFile.name;
        }

        let remixCreated = false;
        let remixCreatedId = null;
        let remixCreatedTid = null;
        let firstElementEid;

        try {
          const response = await PSO.createRemixWithPhoto(remixArguments);
          if (response.result === 'success' && response.remix_id) {
            returnV = true;
            remixCreated = true;
            remixCreatedId = response.remix_id;
            remixCreatedTid = response.tid;
            resultArray.tid = remixCreatedTid;
            resultArray.rid = remixCreatedId;
            
            if (localRemixMedia[0].type === 'textphoto') {
              if (response.element_id) {
                const elementId = response.element_id;
      
                const replacePhotoArgs = {
                  al: al,
                  un: un,
                  rid: remixCreatedId,
                  eid: elementId,
                  etxtjson: JSON.stringify(etxtjsonCreate),
                  Filedata: renderedFileBLOBCreate,
                  Filename: 'remixPhoto.jpg', 
                }
                await PSO.replacePhotoInRemix(replacePhotoArgs);

                // Changing foto animation to crop to FIT
                const cropToFixArgs = {
                  al: al,
                  un: un,
                  etype: 1,
                  eid: elementId,
                  eaid: '1003'
                }
                await PSO.modifyElementGlobal(cropToFixArgs);
              }
            }
            if (localRemixMedia[0].temporary && response.element_id) {
              temporaryEids.push(response.element_id);
            }
          } else {
            returnV = false;
            resultArray.message = Strings('error_while_creating_video');
          }
        } catch (err) {
          returnV = false;
          console.error(err);
        }

        if (remixCreated) {
          // Sending more media
          if (localRemixMedia.length > 1) {
            for (let i = 1; i < localRemixMedia.length; i++) {
              const currentImage = localRemixMedia[i];

              if (currentImage && currentImage.type === 'mediapack') {
                try {
                  const sendPhotoArgs = { al: al, un: un, rid: remixCreatedId, uptype: 1, upfn: currentImage.eid };
                  const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
                  if (i === localRemixMedia.length - 1) {
                    // Last element sent - first element of the frid
                    if (response && response.element_id) {
                      firstElementEid = response.element_id;
                    }
                  }
                } catch (error) {
                  console.error(error);
                }
              } else if (currentImage && currentImage.type === 'file') {
                const targetFile = await ProcessImageForUpload(
                  currentImage.file,
                  process.env.REACT_APP_PZ_EXIF_JS,
                  process.env.REACT_APP_MIN_UPLOAD_PHOTO_WIDTH,
                  process.env.REACT_APP_MIN_UPLOAD_PHOTO_HEIGHT,
                  process.env.REACT_APP_MAX_UPLOAD_PHOTO_WIDTH,
                  process.env.REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT,
                  true
                );
                if (targetFile && targetFile !== undefined) {
                  // const fileDataURI = currentImage.src;
                  // const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
                  try {
                    const sendPhotoArgs = { al: al, un: un, rid: remixCreatedId, Filedata: targetFile, Filename: targetFile.name };
                    const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
                    if (i === localRemixMedia.length - 1) {
                      // Last element sent - first element of the frid
                      if (response && response.element_id) {
                        firstElementEid = response.element_id;
                      }
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
              } else if (currentImage && currentImage.type === 'blobfile') {
                const targetFile = currentImage.file;
                if (targetFile && targetFile !== undefined) {
                  const fileBLOB = targetFile;
                  try {
                    const sendPhotoArgs = { al: al, un: un, rid: remixCreatedId, Filedata: fileBLOB, Filename: 'remixPhoto.jpg' };
                    const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
                    if (i === localRemixMedia.length - 1) {
                      // Last element sent - first element of the frid
                      if (response && response.element_id) {
                        firstElementEid = response.element_id;
                      }
                    }
                    if (currentImage.temporary && response && response.element_id) {
                      temporaryEids.push(response.element_id);
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
              } else if (currentImage && currentImage.type === 'textphoto') {
                if (currentImage.layers && currentImage.layers.length > 0 && currentImage.layers[0] !== null) {
                  const originalFileBLOB = FileHelper.dataURItoBlob(await RemixHelper.generateBasePhotoWithLayer(currentImage.layers));
                  const renderedFileBLOB = FileHelper.dataURItoBlob(currentImage.src);
      
                  const txts = [];
                  if (currentImage.layers && currentImage.layers.length > 0) {
                    currentImage.layers.forEach((item) => {
                      if (item.type === 'text') {
                        let x = item.x;
                        let y = item.y;
                        const h = item.h;
                        const w = item.w;

                        if (item.textAlign === 'center') {
                          if (item.renderedW) {
                            x = x - (item.renderedW / 2);
                          }
                          if (item.renderedH) {
                            y = y - (item.renderedH / 2);
                          }
                        }

                        x = x - TextPhotoDefaults.COMPATIBILITY_X_FACTOR;
                        y = y - TextPhotoDefaults.COMPATIBILITY_Y_FACTOR;

                        txts.push({
                          t: RemixHelper.generateTextLayerBreakLine(item),
                          c: encodeURIComponent(item.color),
                          y: y,
                          x: x,
                          h: h,
                          w: w,
                          a: 0,
                          s: item.fontSize / TextPhotoDefaults.SCALE_FACTOR,
                          f: encodeURIComponent(item.font),
                          app: 'web'
                        });
                      }
                    });
                  }
      
                  try {
                    const etxtjson = { txts: txts, isTxtPhoto: true };
                    const sendPhotoArgs = {
                      al: al,
                      un: un,
                      rid: remixCreatedId,
                      Filedata: originalFileBLOB,
                      Filename: 'remixPhoto.jpg', 
                      etxtjson: JSON.stringify(etxtjson)
                    }
                    const resp = await PSO.sendPhotoToRemix(sendPhotoArgs);

                    if (resp && resp.result === 'success' && resp.element_id) {
                      const elementId = resp.element_id;

                      const replacePhotoArgs = {
                        al: al,
                        un: un,
                        rid: remixCreatedId,
                        eid: elementId,
                        etxtjson: JSON.stringify(etxtjson),
                        Filedata: renderedFileBLOB,
                        Filename: 'remixPhoto.jpg', 
                      }
                      await PSO.replacePhotoInRemix(replacePhotoArgs);

                      // Changing foto animation to crop to FIT
                      const cropToFixArgs = { al: al, un: un, etype: 1, eid: elementId, eaid: '1003' };
                      await PSO.modifyElementGlobal(cropToFixArgs);
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
              } else if (currentImage && currentImage.type === 'unsplash') {
                const targetFile = currentImage;
                if (targetFile && targetFile !== undefined) {
                  const fileDataURI = currentImage.src;
                  const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
                  try {
                    const sendPhotoArgs = { al: al, un: un, rid: remixCreatedId, Filedata: fileBLOB, Filename: targetFile.name };
                    const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
                    if (i === localRemixMedia.length - 1) {
                      // Last element sent - first element of the grid
                      if (response && response.element_id) { firstElementEid = response.element_id; }
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
              } else if (currentImage && currentImage.type === 'video') {
                const targetFile = currentImage;
                if (targetFile && targetFile !== undefined) {
                  const fileDataURI = currentImage.src;
                  const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
                  try {
                    const sendVideoArgs = { al: al, un: un, rid: remixCreatedId, Filedata: fileBLOB, Filename: targetFile.file.name };
                    const response = await PSO.sendVideoToRemix(sendVideoArgs);
                    if (i === localRemixMedia.length - 1) {
                      // Last element sent - first element of the grid
                      if (response && response.element_id) { firstElementEid = response.element_id; }
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
              }
            }
          }

          if (songType === 2 && appleMusicParams !== null) {
            // Defining Apple Music
            try {
              const response = await PSO.modifyRemix({ un: un, al: al, rid: remixCreatedId, args: appleMusicParams });
              if (response.result !== 'success' && response.error) {
                console.error(response.error);
              }
            } catch (err) {
              console.error(err);
            }
          } else if (songType === 3) {
            // Defining Original Song
            if (song && song.obj && song.obj.element_id) {
              try {
                const args = { usoid: song.obj.element_id, uso: 1 };
                const response = await PSO.modifyRemix({ un: un, al: al, rid: remixCreatedId, args: args });
                if (response.result !== 'success' && response.error) {
                  console.error(response.error);
                }
              } catch (err) {
                console.error(err);
              }
            }
          }

          // Setting the remix cover to first photo of grid
          if (firstElementEid) {
            try {
              await PSO.setRemixCover({ un: un, al: al, rid: remixCreatedId, eid: firstElementEid });
            } catch (err) {
              console.error(err);
            }
          }

          // Removing temporary items
          if (temporaryEids.length > 0) {
            for (let i = 0; i < temporaryEids.length; i++) {
              if (temporaryEids[i] !== firstElementEid) {
                try {
                  await PSO.removeElementFromRemix({un: un, al: al, rid: remixCreatedId, etype: 1, eid: temporaryEids[i] });
                } catch (err) {
                  console.error(err);
                }
              }
            }
          }

          // Calling notifyRemixReady
          try {
            await PSO.notifyRemixReady({ un: un, al: al, rid: remixCreatedId });
          } catch (err) {
            console.error(err);
          }

        }
      } else {
        returnV = false;
      }
    }
  }

  resultArray.returnV = returnV;
  return resultArray;
}
